// Add a row to Google Sheets using SheetDB.io (or similar service)
// 1. Go to https://sheetdb.io, connect your Google Sheet, and get your API endpoint
// 2. Replace YOUR_SHEETDB_ID below with your actual SheetDB ID

export async function addRowToGoogleSheet(values) {
  const url = 'https://sheetdb.io/api/v1/gk8qk9qmzzeub'; // Replace with your SheetDB endpoint
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data: values }),
  });
  if (!response.ok) throw new Error('Failed to add row');
  return response.json();
}
